import { Controller } from "@hotwired/stimulus"

let projectMilestoreChart;

export default class extends Controller {
  connect() {
    projectMilestoreChart = echarts.init(document.getElementById('project-milestore-chart'));

    const xAxisData = JSON.parse(this.data.get("x_axis"));
    const departmentCodes = JSON.parse(this.data.get("department_codes"));
    const monthEndUpdateRate = JSON.parse(this.data.get("month_end_update_rate"));
    const currentUpdateRate = JSON.parse(this.data.get("current_update_rate"));
    const viewDeptcodeSum = this.data.get("view_deptcode_sum") === "true";
    const isDarkTheme = document.body.dataset.coreuiTheme === "dark";
    const chartTitleColor = isDarkTheme ? '#f8f9fa' : '#212529';
    const chartTextColor = isDarkTheme ? '#d7dfeb' : '#495057';
    const chartAxisColor = isDarkTheme ? '#aebccc' : '#6c757d';
    const chartSplitLineColor = isDarkTheme ? 'rgba(215, 223, 235, 0.35)' : '#d9dfe7';

    const option = {
        legend: {
            data: ['月底更新情况','当前更新情况'],
            align: 'left',
            bottom: 12,
            textStyle: { color: chartTextColor }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        grid: {
          left: 56,
          right: 100,
          top: 72,
          bottom: 140
        },
        toolbox: {
          feature: {
            dataView: {},
            saveAsImage: {
                pixelRatio: 2
            }
          }
        },
        xAxis: {
          data: xAxisData,
          silent: true,
          axisLabel: {
            color: chartTextColor,
            interval: 0,
            rotate: -55,
            width: 120,
            overflow: 'break',
            hideOverlap: true,
            margin: 16
          },
          axisLine: { lineStyle: { color: chartAxisColor } },
          axisTick: { lineStyle: { color: chartAxisColor } },
          splitLine: {
              show: false
          }
        },
        yAxis: [{
          type: 'value',
          name: '项目里程碑更新率',
          nameGap: 34,
          min: 0,
          max: 100,
          axisLabel: {
            color: chartTextColor,
            formatter: '{value}%'
          },
          nameTextStyle: { color: chartTitleColor, align: 'left' },
          axisLine: { lineStyle: { color: chartAxisColor } },
          axisTick: { lineStyle: { color: chartAxisColor } },
          splitLine: { lineStyle: { color: chartSplitLineColor } }
        }],
        series: [{
          name: '月底更新情况',
          type: 'line',
          data: monthEndUpdateRate.map(value => ({ value, label: { position: value === 0 ? 'top' : 'bottom' } })),
          color: '#5470c6',
          symbolSize: 10,
          labelLayout: { hideOverlap: true },
          label: {
            show: true,
            position: 'bottom',
            color: chartTitleColor,
            formatter: params => params.value === currentUpdateRate[params.dataIndex] ? '' : `${params.value}%`
          }
        }, {
          name: '当前更新情况',
          type: 'line',
          data: currentUpdateRate,
          color: '#738496',
          symbolSize: 10,
          labelLayout: { hideOverlap: true },
          label: {
            show: true,
            position: 'top',
            color: chartTitleColor,
            formatter: '{c}%'
          }
        }]
    };
    function drill_down_contract_detail(params) {
      if (params.componentType === 'series') {
        if (params.seriesType === 'line') {
          const department_name = xAxisData[params.dataIndex];
          const department_code = departmentCodes[params.dataIndex];
          const month_name = $('#month_name').val();
          const sent_data = { department_name, department_code, month_name, view_deptcode_sum: viewDeptcodeSum };
          let drill_down_url = '/report/project_milestore/detail_drill_down';

          $.ajax(drill_down_url, {
            data: sent_data,
            dataType: 'script'
          });
        }
      }
    }

    projectMilestoreChart.on('click', drill_down_contract_detail);

    projectMilestoreChart.setOption(option, false);
    setTimeout(() => {
      projectMilestoreChart.resize();
    }, 200);
  }

  layout() {
    projectMilestoreChart.resize();
  }

  disconnect() {
    projectMilestoreChart.dispose();
  }
}
